import getThemeMerger from 'util/getThemeMerger'

export default getThemeMerger((currentTheme) => ({
  overrides: {
    MuiTypography: {
      body1: {
        color: currentTheme.palette.primary.main,
        textAlign: 'right',
      },
    },
    MuiTableBody: {
      root: {
        '& td': {
          borderBottom: 'none',
        },
      },
    },
  },
}))
